import { Component, OnInit, ViewChild } from '@angular/core';
import { FocostcenterService } from './_service/focostcenter.service';

interface USERS {
  stateCode: String;
  costCenterDesc: String;
  costCenterFo: String;
}
@Component({
    selector: 'app-fo-cost-center',
    templateUrl: './fo-cost-center.component.html',
    styleUrls: ['./fo-cost-center.component.css']
})
/** FoCostCenter component*/
export class FoCostCenterComponent {
    /** FoCostCenter ctor */

  expense1: any;

  constructor(private _service: FocostcenterService) { }

    ngOnInit() {
      $(".loader-mn").hide();

      this._service.getdatadown().subscribe
      (res => {
        if (res) {
         debugger;
          this.expense1 = res;
         // this.OnYearChange1(Year);

       }
        });


    }

  onSave(Costcd: string, CostDesc: string ) {
    debugger;
    $(".loader-mn").show();
    if (Costcd != undefined && CostDesc != undefined) {
      this._service.postdata(Costcd, CostDesc).subscribe
        (res => {
          debugger;
          if (res == 1) {
            alert(CostDesc + ' Cost Center is Mapped  Succesfully');

            this._service.getdatadown().subscribe
              (res => {
                if (res) {
                  debugger;
                  this.expense1 = res;
                  // this.OnYearChange1(Year);

                }
              });

            $(".loader-mn").hide();



          }
          else {
            alert('An Error Occur');
            $(".loader-mn").hide();
          }
        });
    }
    else {
      alert('Please Enter Cost Center Code/ Description.');
      $(".loader-mn").hide();
    }
      
   
  }


}

